import { render } from "./AudioQuiz.vue?vue&type=template&id=6d74fdbc"
import script from "./AudioQuiz.vue?vue&type=script&lang=js"
export * from "./AudioQuiz.vue?vue&type=script&lang=js"

import "./AudioQuiz.vue?vue&type=style&index=0&id=6d74fdbc&lang=css"

import exportComponent from "D:\\Medienprojekt_2122\\medienprojekt\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__